module.exports = __webpack_public_path__ + "img/zscqyjy.cfd201f4.png";